<div class="filter-header">
    <div class="title-back mR10 cPointer"
        *ngIf="includeBackClick"
        (click)="backClick.emit()"
    >
        <app-icon [faIcon]="'fas fa-chevron-left'" [fontSize]="'22px'"></app-icon>
    </div>

    <p *ngIf="titleKey" class="filter-header-text flexGrow1 flexRow gap5">
        <span>{{titleKey | translate}}</span>
        <span *ngIf="filtersCount" class="filter-count">({{filtersCount}})</span>
    </p>
    
    <a class="filter-action"
        *ngIf="includeClearClick"
        [class.disabled]="filtersCount === 0"
        (click)="clearFilters.emit()"
    >
        {{ 'generics.clear-all' | translate }}
    </a>
</div>
